module.exports = __webpack_public_path__ + "static/media/Coaching_Conversation.256fb8e8.svg";